module.exports = __webpack_public_path__ + "img/gamescom.b82f531b.png";